module.exports = __webpack_public_path__ + "img/main.048d672.jpg";